import { useContext, useEffect, useState } from "react";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import Card from "react-bootstrap/Card";
import Stack from "react-bootstrap/Stack";
import { LanguageContext } from "../../../utils/Language";
import { DoctorService } from "../../../services";

function Notifications() {
  const { dictionary } = useContext(LanguageContext);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    DoctorService.getNotifications().then((response) => {
      setNotifications(response);
    });

    return () => {};
  }, []);

  return (
    <Dropdown className="notifications" align="end">
      <Dropdown.Toggle as={Button} variant="light" id="dropdown-basic">
        <i className="fa fa-bell">
          <Badge bg="primary">
            {notifications.filter((item) => item.RUserId === 0).length}
          </Badge>
        </i>
        <span className="visually-hidden">unread messages</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Stack gap="1" style={{ overflowY: "auto", maxHeight: "50vh" }}>
          <Dropdown.Header>{dictionary.Notifications}</Dropdown.Header>
          {notifications.map((notification, index) => {
            return (
              <Card
                key={notification.Id || index}
                as={Dropdown.Item}
                bg="light"
                text="dark"
                style={{
                  width: "18rem",
                  fontSize: "0.7rem",
                  cursor: "pointer",
                }}
                className="card mb-1"
                href={"/patients/" + notification.PatientId}
              >
                <Card.Body>
                  <Card.Subtitle>
                    You have {notification.RUserId === 0 ? "unread" : "a"}{" "}
                    message
                  </Card.Subtitle>
                  <Card.Text>
                    <b>{notification.FirstName} {notification.FamilyName}:</b> {notification.Note.replace(/(.{140})..+/, "$1...")}
                  </Card.Text>
                </Card.Body>
              </Card>
            );
          })}
        </Stack>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default Notifications;
